import React from 'react'
import styled from "styled-components";

const Button = (props) => {
  return (
    <ButtonView
      disabled={props.disabled}
      backgroundColor={props.disabled ? "gray" : props.backgroundColor}
      color={props.color}
      fontSize={props.fontSize}
      padding={props.padding}
      borderColor={props.borderColor}
      borderRadius={props.borderRadius}
      onClick={props.onClick}
      width={props.width}
    >{props.label}</ButtonView>
  )
}

export default Button

const ButtonView = styled.button`
  /* Adapt the colors based on primary prop */
  disabled: ${props => props.disabled ? props.disabled : false };
  background: ${props => props.backgroundColor ? props.backgroundColor : "white"};
  color: ${props => props.color ? props.color : "white"};

  font-size: ${props => props.fontSize ? props.fontSize : "2em"};
  padding: ${props => props.padding ? props.padding : "0.25em 1em"};
  width: ${props => props.width ? props.width : "auto"};
  border: 2px solid ${props => props.borderColor ? props.borderColor : "white"};
  border-radius: ${props => props.borderRadius ? props.borderRadius : "8px"};
`;
